import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { Guid } from 'guid-typescript';
import { JobModel } from 'src/app/models/job.model';
import { ServiceModel } from 'src/app/models/service.model';
import { TaskGruopModel } from 'src/app/models/task-group.model';
import { FileServerService } from 'src/app/services/file-server.service';
import { FileServerModel } from 'src/app/models/file-server.model';
import { ProductService } from 'src/app/services/product.service';
import { ToastService } from 'src/app/services/toast.service';
import { WorkTaskService } from 'src/app/services/work-task.service';
import { UserService } from 'src/app/shared/services/user.service';
import { UploaderSettingModel } from 'src/app/models/uploaderSetting.model';
import { CommonFunctionsConfiguratorService } from 'src/app/shared/services/swal-fire-configurator.service';

import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatInput } from '@angular/material/input';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { FileUploaderComponent } from '../../../shared/components/file-uploader/file-uploader.component';
import { FilterByServiceNamePipe } from '../../../shared/pipes/filter-by-service-name.pipe';

import { MatButton } from '@angular/material/button';
import { PageHeaderComponent } from 'src/app/shared/ui/page-header/page-header.component';
import { EmptyStateComponent } from 'src/app/shared/ui/empty-state/empty-state.component';

@Component({
    selector: 'app-service-list',
    templateUrl: './service-list.component.html',
    styleUrls: ['./service-list.component.scss'],
    imports: [MatIcon, FormsModule, ReactiveFormsModule, MatFormField, MatInput, MatSelect, MatOption, MatSlideToggle, FileUploaderComponent, FilterByServiceNamePipe, MatButton, PageHeaderComponent, EmptyStateComponent]
})
export class ServiceListComponent implements OnInit {
  private readonly _liveAnnouncer = inject(LiveAnnouncer);
  usrSvc = inject(UserService);
  dialog = inject(MatDialog);
  productSvc = inject(ProductService);
  toastr = inject(ToastService);
  private readonly workTaskSvc = inject(WorkTaskService);
  fileServerSrv = inject(FileServerService);
  private readonly swalFire = inject(CommonFunctionsConfiguratorService);


  jobs: JobModel[] = [];
  title: string = 'Nuevo servicio';

  services: ServiceModel[] = [];
  taskGroups: TaskGruopModel[] = [];
  searchText!: string;
  imageSource!: string;

  serviceForm = new UntypedFormGroup({
    id: new UntypedFormControl(Guid.EMPTY),
    name: new UntypedFormControl('', Validators.required),
    description: new UntypedFormControl('', [
      Validators.required,
      Validators.maxLength(1000),
    ]),
    isOfferedOnline: new UntypedFormControl(false),
    categoryId: new UntypedFormControl(null, Validators.required),
    subCategoryId: new UntypedFormControl(null, Validators.required),
    serviceImg: new UntypedFormControl(null),
    file: new UntypedFormControl(null),
  });

  uploadersetting!: UploaderSettingModel;

  ngOnInit(): void {
    this.uploadersetting = {
      accept: ['image/png', 'image/jpg', 'image/jpeg'],
      inputWhith: '50%',
      imgWhith: '50%',
      imgHeight: '100%',
      imgMaxHeight: '270px',
      imgMaxWhith: '50%',
      controller: 'fileServerSrv.Services',
      formGroup: this.serviceForm,
    };
    this.getTaskGroups();
  }

  ngAfterViewInit(): void {
    this.getServices();
  }

  getServices() {
    this.productSvc.getServices().subscribe((data: ServiceModel[]) => {
      this.services = data;
    });
  }

  deleteService(service: any) {
    let serviceId = service.id.toString();
    this.swalFire
      .SwalFireQuestion(
        'Eliminación',
        '¿Desea eliminar este servicio?',
        'Eliminar',
        'Cancelar'
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.productSvc.deleteService(service.id).subscribe(
            (data) => {
              this.fileServerSrv
                .GetTaskFiles(serviceId, this.fileServerSrv.Products)
                .subscribe((dataimg) => {
                  dataimg.forEach((img) => {
                    this.fileServerSrv.delete(img.id).subscribe();
                  });
                });

              this.toastr.success(
                'Actualización',
                'El servicio se eliminó correctamente.'
              );

              this.getServices();
            },
            (err) => {
              this.toastr.error('Error', 'No se pudo eliminar el servicio.');
            }
          );
        }
      });
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  getTaskGroups() {
    this.workTaskSvc.getTaskGroups().subscribe((data: TaskGruopModel[]) => {
      this.taskGroups = [...this.taskGroups, ...data];
    });
  }

  editService(serviceId: ServiceModel) {
    this.getServiceDetails(serviceId.id);
  }

  /** The list row of the service open in the form (the form id is the selection; EMPTY = new service). */
  isSelectedService(service: ServiceModel): boolean {
    const id = this.serviceForm.controls['id'].value?.toString();
    return !!id && id !== Guid.EMPTY && service.id?.toString() === id;
  }

  hasSelectedService(): boolean {
    const id = this.serviceForm.controls['id'].value?.toString();
    return !!id && id !== Guid.EMPTY;
  }

  cleanForm() {
    this.serviceForm.reset();
    this.serviceForm.controls['isOfferedOnline'].setValue(false);
    this.serviceForm.controls['id'].setValue(Guid.EMPTY);
  }

  onSubmit() {
    const description = this.serviceForm.controls['description'].value;

    if (description && description.length > 1000) {
      // Mostrar mensaje de error
      this.toastr.error(
        'Error',
        'La descripción no puede exceder los 1000 caracteres.'
      );
      return; // Detener la ejecución del método aquí
    }
    if (this.serviceForm.valid) {
      let model = this.serviceForm.value as ServiceModel;
      if (model.id == Guid.createEmpty()) {
        this.productSvc.saveService(model).subscribe(
          () => {
            this.toastr.success(
              'Nuevo Servicio',
              'Se ha guardado el nuevo servicio exitosamente'
            );
            this.cleanForm();
            this.getServices();
          },
          () => {
            this.toastr.error('Error', 'No se pudo guardar el nuevo servicio.');
          }
        );
      } else {
        this.productSvc.updateService(model).subscribe(
          (result: any) => {
            if (
              this.serviceForm.controls.serviceImg.value &&
              !this.serviceForm.controls.serviceImg.value.id
            ) {
              let fileServerModel = this.serviceForm.controls.serviceImg
                .value as FileServerModel;
              this.fileServerSrv
                .UploadTaskFile(
                  model.id.toString(),
                  fileServerModel,
                  this.fileServerSrv.Services
                )
                .subscribe();
            }
            this.toastr.success(
              'Edición de servicio',
              'Se ha actualizado el servicio exitosamente'
            );
            this.getServices();
            this.cleanForm();
          },
          () => {
            this.toastr.error('Error', 'No se pudo guardar el nuevo servicio.');
          }
        );
      }
    }
  }

  /** A subcategory belongs to one task type: changing the type drops the old one so required applies again. */
  onCategoryChange(groupId: string) {
    this.serviceForm.controls['subCategoryId'].setValue(null);
    this.getJobs(groupId);
  }

  getJobs(group: any) {
    this.workTaskSvc.getJobs(group).subscribe((data: JobModel[]) => {
      this.jobs = data;
    });
  }

  getServiceDetails(serviceId: Guid) {
    this.cleanForm();
    this.productSvc.getService(serviceId).subscribe((details) => {
      this.serviceForm.patchValue(details);

      if (details.file != null) {
        let model: FileServerModel = {
          id: details.file.fileId.toString(),
          groupId: serviceId.toString(),
          name: 'serviceImg',
          imageSrc: details.file.url,
        };
        this.serviceForm.controls[model.name].patchValue(model);
      }

      this.getJobs(details.categoryId);
    });
  }

  hideUploadFile() {
    return (
      !this.serviceForm.controls.id.value ||
      this.serviceForm.controls.id.value == Guid.EMPTY
    );
  }
}
